import { render } from "./ImportantFilesPage.vue?vue&type=template&id=e3db53a4&ts=true"
import script from "./ImportantFilesPage.vue?vue&type=script&lang=ts"
export * from "./ImportantFilesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__